import { createContext, useReducer, useEffect } from 'react';

export const CultivationCompanyContext = createContext();

export const cultivationCompanyReducer = (state, action) => {
  switch (action.type) {
    case 'SET_CULTIVATIONCOMPANY':
      localStorage.setItem('cultivationCompany', JSON.stringify(action.payload)); // Opslaan in localStorage
      return { cultivationCompany: action.payload };
    default:
      return state;
  }
};

export const CultivationCompanyContextProvider = ({ children }) => {
  const storedCompany = JSON.parse(localStorage.getItem('cultivationCompany')); // Ophalen uit localStorage
  const [state, dispatch] = useReducer(cultivationCompanyReducer, {
    cultivationCompany: storedCompany || null, // Gebruik opgeslagen waarde als die er is
  });

  return (
    <CultivationCompanyContext.Provider value={{ ...state, dispatch }}>
      {children}
    </CultivationCompanyContext.Provider>
  );
};
